// extracted by mini-css-extract-plugin
module.exports = {"pagination":"_2MeAQH","active":"_3t1RVW","hiddenArrow":"_2xTCI9","breakLabel":"_1SvPox"};